import {
    AnimationBaseController,
    IAnimationControllerConfiguration,
    ImageResourceItem,
    Inject,
    ModelEvents,
    SoundType,
} from '@denishussar/html5-game-engine';
import {AnimationContents} from '../../../../AnimationContents';
import {IAlbumData, IPictureData} from '../../../Services/CloudDB/Contract';
import {LocalizationContents} from '../../../LocalizationContents';
import {GameLogic} from '../../../Logic/GameLogic';
import {GameModel, GameStateEnum} from '../../../Models/GameModel';
import {ITopBarMenuControllerOptions, TopBarMenuController} from '../TopBarMenuController';
import {CatalogFolderController, IPictureTexture} from './CatalogFolderController';
import {CatalogListController, ICatalogListControllerOptions} from './CatalogListController';
import {ModalsNames} from '../../../Common/MadalsManager/ModalsList';
import {getSpriteFromUrl} from '../../../Common/getSpriteFromUrl';
import {
    IConfirmationsBuyEmbroideryControllerOptions,
} from '../../Modals/Confirmations/ConfirmationsBuyEmbroideryController';
import {Container, Point} from 'pixi.js';
import {ConfirmationsYouRewardType} from '../../Modals/Confirmations/ConfirmationsYouRewardController';
import {AlbumsLibrary} from '../../../Models/AlbumsLibrary';
import {IConfirmationsConfirmControllerOptions} from '../../Modals/Confirmations/ConfirmationsConfirmController';
import {DevConfig} from '../../../Common/DevConfig';
import {CatalogFolderWithoutGloryController} from './CatalogFolderWithoutGloryController';
import {
    GameEvent,
    GameEventPopupButtonName,
    GameEventPopupName,
    GameEventSceneButtonClick,
} from '../../../Constants/GameEvent';
import {AdsLogic} from "../../../Logic/Ads/AdsLogic";
import {UIActionController} from "../Main/UIActionController";
import {ButtonController, IButtonControllerOptions} from "../../../Common/ButtonController";
import {REWARDED_ADS_TYPE} from "../../../Logic/Ads/BaseAdsLogic";

export interface ICatalogControllerOptions {
    opacity: boolean;
}

export class CatalogController extends AnimationBaseController {
    $model: GameModel;

    private topBarMenu: TopBarMenuController;
    private list: CatalogListController;
    private folder: CatalogFolderController;
    private albums: IAlbumData[];

    private allowSelected: boolean = true;

    public constructor(
        @Inject private options: ICatalogControllerOptions,
        @Inject private gameLogic: GameLogic,
        @Inject private adsLogic: AdsLogic,
        @Inject private modelEvents: ModelEvents,
        @Inject private model: GameModel,
    ) {
        super('CatalogController');
    }

    protected getConfiguration(): IAnimationControllerConfiguration {
        const childControllers = {
            topBarMenu: {
                controller: TopBarMenuController,
                model: this.$model,
                options: <ITopBarMenuControllerOptions>{
                    showExitButton: false,
                    showSettings: true,
                    showCoins: true,
                    hideExitButtonInSettings: true,
                    onClickExit: (status: boolean) => {
                        this.gameLogic.setState(GameStateEnum.main);
                    },
                },
            },
            list: {
                controller: CatalogListController,
                instanceName: 'albums.albums_list',
                model: this.$model,
                options: <ICatalogListControllerOptions>{
                    onClick: (albumId: string) => {
                        this.handleListClick(albumId);
                    },
                },
            },
            action: { // TODO: what for is this?
                controller: UIActionController,
                model: this.$model,
                options: {
                    showBox: true,
                },
            },
            btn_facebook: {
                instanceName: 'albums.btn_facebook',
                controller: ButtonController,
                model: this.$model,
                options: <IButtonControllerOptions>{
                    onClick: (status: boolean) => {
                        window.open('https://nordbeaver.com/subscribe/', '_blank').focus();
                    },

                },
            },
        };
        if (DevConfig.HIDE_ALBUM_GLORIA) {
            childControllers['folder'] = {
                controller: CatalogFolderWithoutGloryController,
                instanceName: 'albums.albums_folder',
                model: this.$model,
                options: <ICatalogListControllerOptions>{
                    onClick: (pictureId: string) => {
                        this.handleFolderClick(pictureId);
                    },
                },
            };
        } else {
            childControllers['folder'] = {
                controller: CatalogFolderController,
                instanceName: 'albums.albums_folder',
                model: this.$model,
                options: <ICatalogListControllerOptions>{
                    onClick: (pictureId: string) => {
                        this.handleFolderClick(pictureId);
                    },
                },
            };
        }

        return <IAnimationControllerConfiguration>{
            resources: {
                'spinner': new ImageResourceItem('spinner', 'spinner.png'),
            },
            animationContent: AnimationContents.CATALOG_JSON,
            libraryName: 'albums_container',
            childControllers: childControllers,
            modelWatch: {
                gameState: (state) => {
                    if (state === GameStateEnum.catalog) {
                        // setTimeout(() => {
                        //     this.handleListClick(this.$model.currentAlbum, false);
                        // }, 100);
                    }
                },
            },
        };
    }

    protected onInitialize() {
        this.allowSelected = true;

        this.albums = this.$model.albumLibrary.getAllAlbums();
        this.topBarMenu = this.$childControllers.get('topBarMenu');
        this.list = this.$childControllers.get('list');
        this.folder = this.$childControllers.get('folder');

        const book = this.getDisplayObjectByQuery('albums.albums_folder.history_gloria.book')[0] as Container;
        book.buttonMode = true;
        book.interactive = true;
        book.on('pointerdown', () => this.handleListClick(AlbumsLibrary.MY_COLLECTION));

        // console.dir(this);
        // this.topBarMenu.$childControllers.get('')

        // setTimeout(() => {
        //     this.
        // }, 1500);
        if (this.options.opacity) {
            this.alpha = 0;
        }

        if (this.adsLogic.isReady) {
            // this.adsLogic.adsLogic.requestAd(ADS_TYPE.BANNER);
        }

        this.handleListClick(AlbumsLibrary.MY_COLLECTION)
        // console.log("INITIALIZED")

        const facebookBtn = this.$childControllers.get('btn_facebook');
        facebookBtn.visible = window['current_social'] !== 'azerion';
    }

    protected onDestroy() {
        super.onDestroy();

        if (this.adsLogic.isReady) {
            this.adsLogic.adsLogic.clearAllBanners();
        }
    }

    protected onResize(width: number, height: number, scale: number) {
        super.onResize(width, height, scale);
        // console.log("RESIZED")

        const topLeftPoint = this.display.toLocal(new Point(0, 0), this.renderer.stage);
        const actionContainer = this.$childControllers.get('action');
        // this.setPosByQuery('action', topLeftPoint.x, topLeftPoint.y);
        actionContainer.x = topLeftPoint.x + 325;
        actionContainer.y = topLeftPoint.y;

        // console.log("RESIZED!")
    }

    public handleListClick = (albumId: string, withDispatch: boolean = true) => {
        if (this.folder.inSelecting) return;
        this.list.selectAlbum(albumId);
        this.folder.selectAlbum(albumId);
        this.topBarMenu.label = LocalizationContents.getText(this.$model.albumLibrary.getAlbumData(albumId).title);
        this.topBarMenu.labelX = -140;

        if (withDispatch) {
            this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, { buttonName: albumId });
        }
    };

    private handleFolderClick = async (pictureId: string) => {
        if (!this.allowSelected) {
            return;
        }

        // @ts-ignore
        this.modelEvents.dispatch(this.model, GameEvent.popupButtonClick, { buttonName: `Level_${pictureId}`, popupName: this.folder.currenAlbum });

        const save = this.gameLogic.getSave(pictureId);
        if (save || this.$model.albumLibrary.doesPictureBelongToGloria(pictureId)) {
            // open picture
            const percent = save ? this.gameLogic.getPercentageProgress(save) : 0;

            if (percent === 100) {
                this.gameLogic.setState(GameStateEnum.achievement);
                this.gameLogic.showCompletedPicture(this.$model.albumLibrary.getPictureData(pictureId));
            } else {
                this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName: 'Play' });
                this.gameLogic.setPicture(this.$model.albumLibrary.getPictureData(pictureId));
            }
        } else {
            const texture = await this.getTextureFromPicture(this.$model.albumLibrary.getPictureData(pictureId));
            const size = texture.texture.width;
            const price = this.gameLogic.balanceManager.getPicturePrice(size);

            this.gameLogic.modalsManager.show(
                this.gameLogic.balanceManager.isPictureRewardAvaliable(size) ? ModalsNames.buyEmbroidery : ModalsNames.buyCoinsOnlyEmbroidery,
                <IConfirmationsBuyEmbroideryControllerOptions>
                {
                    texture: texture,
                    text: LocalizationContents.getText('BuyEmbroideryTitle'),
                    valueText: `${size}x${size}`,
                    buyText: price.toString(),
                    receiveText: LocalizationContents.getText('Receive!'),
                    buyDisabled: !this.gameLogic.canBuyPicture(size),
                    receiveDisabled: this.adsLogic.isReady ? false /* !this.adsLogic.adsLogic.isAvailableRewardedAd(REWARDED_ADS_TYPE.CATALOG_PICTURE) */ : false,
                    receiveClick: () => {
                        this.allowSelected = false;

                        if (this.adsLogic.isReady && this.adsLogic.adsLogic.hasAdBlock()) {
                            this.gameLogic.modalsManager.hide();
                            this.gameLogic.modalsManager.show(ModalsNames.confirm, <IConfirmationsConfirmControllerOptions>{
                                oneButtonMode: true,
                                text: LocalizationContents.getText('Adblock'),
                                yesText: LocalizationContents.getText('Ok'),
                                yesClick: () => {
                                    this.gameLogic.modalsManager.hide()
                                    this.allowSelected = true;
                                },
                            });
                        } else {
                            this.showAdvertisment()
                                .then(() => {
                                    this.modelEvents.dispatch(this.model, GameEvent.makePurchase, {
                                        sceneName: "Main",
                                        popupName: "Catalog",
                                        name: "picture",
                                        pictureId,
                                        type: "ads"
                                    })
                                })
                                .catch(() => {
                                    this.modelEvents.dispatch(this.model, GameEvent.makePurchase, {
                                        sceneName: "Main",
                                        popupName: "Catalog",
                                        name: "picture",
                                        pictureId,
                                        type: "wrongAds"
                                    })
                                    console.log('something wrong with ads');
                                })
                                .finally(async () => {
                                    await this.gameLogic.modalsManager.hide();

                                    const onClose = async () => {
                                        this.modelEvents.dispatch(this.$model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.unlock, buttonName: GameEventPopupButtonName.viewAds, levelName: pictureId });

                                        await this.gameLogic.modalsManager.hide();

                                        this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName: 'Play' });
                                        this.gameLogic.setPicture(this.$model.albumLibrary.getPictureData(pictureId), { isSetPictureForAds: true });
                                    };
                                    this.gameLogic.modalsManager.show(ModalsNames.youReward, {
                                        type: ConfirmationsYouRewardType.picture,
                                        texture: texture,
                                        value: `${size}x${size}`,
                                        text: LocalizationContents.getText('Your Reward'),
                                        okText: LocalizationContents.getText('Thanks'),
                                        okClick: () => {
                                            onClose();
                                        },
                                        exitClick: () => {
                                            onClose();
                                        },
                                    });
                                });
                        }
                    },
                    buyClick: () => {
                        if (this.gameLogic.canBuyPicture(size)) {
                            this.allowSelected = false;

                        this.buySomething()
                            .then(async () => {
                                if (this.adsLogic.isReady) {
                                    this.adsLogic.adsLogic.skipNextInterstitial = true;
                                }

                                this.modelEvents.dispatch(this.model, GameEvent.makePurchase, {
                                    sceneName: "Main",
                                    popupName: "Catalog",
                                    name: "picture",
                                    pictureId,
                                    type: "coins",
                                    coins: price,
                                })

                                await this.gameLogic.modalsManager.hide();

                                    const onClose = async () => {
                                        this.modelEvents.dispatch(this.$model, GameEvent.popupButtonClick, { popupName: GameEventPopupName.unlock, buttonName: GameEventPopupButtonName.buy, levelName: pictureId });

                                        this.gameLogic.addBalanceCoins(-price);

                                        await this.gameLogic.modalsManager.hide();

                                        this.modelEvents.dispatch(this.model, GameEvent.sceneButtonClick, <GameEventSceneButtonClick>{ buttonName: 'Play' });
                                        this.gameLogic.setPicture(this.$model.albumLibrary.getPictureData(pictureId));
                                    };
                                    this.gameLogic.modalsManager.show(ModalsNames.youReward, {
                                        type: ConfirmationsYouRewardType.picture,
                                        texture: texture,
                                        value: `${size}x${size}`,
                                        text: LocalizationContents.getText('Your Reward'),
                                        okText: LocalizationContents.getText('Thanks'),
                                        okClick: () => onClose(),
                                        exitClick: () => onClose(),
                                    });
                            })
                        }
                    },
                    exitClick: () => {
                        this.allowSelected = true;
                        this.gameLogic.modalsManager.hide();
                    },
                });
        }
    }

    private async showAdvertisment(): Promise<void> {
        if (!this.adsLogic.isReady) return;
        this.soundManager.muteSoundsByType(true, SoundType.ALL);

        return this.adsLogic.adsLogic.requestAd()
            .finally(() => {
                this.soundManager.muteSoundsByType(false, SoundType.ALL);
            });
    }

    private buySomething(): Promise<void> {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 1000);
        });
    }

    private getTextureFromPicture(picture: IPictureData): Promise<IPictureTexture> {
        const save = this.gameLogic.getSave(picture.id);

        if (save && save.src) {
            return new Promise((resolve) => {
                const texture = PIXI.Texture.from(save.src);

                const timeout = 100;
                const size = 1;
                let timerId = setTimeout(function tick() {
                    if (texture.width > size && texture.height > size) {
                        texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                        resolve({ picture, texture });
                    } else {
                        timerId = setTimeout(tick, timeout);
                    }
                }, timeout);
            });
        }


        return getSpriteFromUrl('assets/' + picture.src, `icon${picture.id}`)
            .then((res) => {
                const { sprite, cached } = res;
                let texture: PIXI.Texture | undefined;
                if (sprite.texture) {
                    texture = sprite.texture;
                    texture.baseTexture.scaleMode = PIXI.SCALE_MODES.NEAREST;
                }

                return Promise.resolve({ picture, texture });
            });
    }
}
